import { installUzNumberFormat } from "./i18n/intlNumbers";
// До первого форматирования: числа в узбекских строках — «90 607», а не «90,607».
installUzNumberFormat();
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./styles/base.css";
import { App } from "./App";
import { I18nProvider, prepareI18n } from "./i18n";

// Не догрузился лениво подключаемый модуль (обычно после выкладки новой
// сборки, пока открыта старая страница): перезагружаем страницу ОДИН раз,
// чтобы она взяла новую сборку, а не падала в белый экран.
window.addEventListener("vite:preloadError", (event) => {
  const key = "agroai-preload-reload";
  try {
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, String(Date.now()));
  } catch {
    return;
  }
  event.preventDefault();
  window.location.reload();
});

const container = document.getElementById("root");
if (!container) throw new Error("В index.html нет элемента #root");

// Ядро каталога языка грузится ДО первого кадра (ADR-0019): без этого
// узбекоязычный человек на каждой загрузке видел бы вспышку русского. Для
// русского ответ синхронный — ядро вшито в пакет.
void prepareI18n().then((boot) => {
  createRoot(container).render(
    <StrictMode>
      <I18nProvider boot={boot}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </I18nProvider>
    </StrictMode>,
  );
});
